import { ArrowDownward, ArrowUpward } from '@mui/icons-material'
import { Badge, Box, BoxProps, Button, Collapse, Typography } from '@mui/material'
import React, { useState } from 'react'

type FilterCollapseProps<D extends React.ElementType<any> = "div"> = BoxProps<D, {
  label?: React.ReactNode,
  count?: number,
  defaultCollapsed?: boolean,
  onCollapse?: (collapsed: boolean) => void
}>

const FilterCollapse = ({children, ...props}: FilterCollapseProps) => {

  const {
    count,
    defaultCollapsed = true,
    label,
    onCollapse,
    ...boxProps
  } = props;
  const [collapsed, setCollapsed] = useState(defaultCollapsed)

  const handleCollapse = (v: boolean) => {
    setCollapsed(v)
    onCollapse && onCollapse(v);
  }

  const padding = 1

  return (
    <Box {...boxProps}>
      <Button
        color="inherit"
        variant="text"
        sx={{
          paddingX: padding,
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between'
        }}
          endIcon={collapsed ? <ArrowDownward /> : <ArrowUpward />}
          onClick={() => handleCollapse(!collapsed)}
        >
        <Typography
          variant="bold"
          flexShrink={1}
          textOverflow={'ellipsis'}
          overflow={'hidden'}
          whiteSpace={'nowrap'}
          marginRight={1}
        >{label}</Typography>
          <Badge sx={{ ml: 'auto', mr: 2}} badgeContent={count} color="primary"/>
      </Button>
      <Collapse in={!collapsed}>
        <Box paddingX={padding}>
          { children }
        </Box>
      </Collapse>
    </Box>
  )
}


export default FilterCollapse